export class ResultSender {
    constructor(questionnaire, state) {
        this.questionnaire = questionnaire;
        this.state = state;
    }
    async sendResults() {
        if (localStorage.getItem('selfcheck-sent'))
            return;
        const body = Object.entries(this.state).map((pair) => ({
            uuid: pair[0],
            answer: pair[1].answer,
        }));
        await fetch('/plus-ewiko/wp-content/plugins/ewiko-selfcheck/api/post_answers.php', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        localStorage.setItem('selfcheck-sent', '1');
    }
}
